import { useLazyQuery } from "@apollo/client";
import { useFocusEffect, useRoute } from "@react-navigation/native";
import {
  Product,
  ProductImage,
} from "@towersystems/roam-common/lib/generated-types";
import { useCallback, useState } from "react";
import { PageErrorOccurred } from "../../../../components";
import {
  PRODUCT_IMAGES_QUERY,
  PRODUCT_QUERY,
} from "../../../../utilities/product/constants";
import { ProductImageDetailsSkeleton } from "../../components";
import { ProductImageDetailsScreenInner } from "./components";
import { useProductImageDetailsRootScreenProvider } from "../../utilities/product-image-details-root";

export interface ProductImageDetailsScreenProps {}

export const ProductImageDetailsScreen = (
  props: ProductImageDetailsScreenProps
) => {
  const { productId } = useProductImageDetailsRootScreenProvider();

  const [error, setError] = useState<boolean>(false);

  const [queryProduct, productResult] = useLazyQuery<{
    product: Product;
  }>(PRODUCT_QUERY);

  const [queryProductImages, imagesResult] = useLazyQuery<{
    productImages: ProductImage[];
  }>(PRODUCT_IMAGES_QUERY);

  function fetchPageData() {
    Promise.all([
      queryProduct({
        variables: {
          id: productId,
        },
      }),
      queryProductImages({
        variables: {
          productId,
        },
      }),
    ])
      .then(() => {
        setError(false);
      })
      .catch((_e) => {
        setError(true);
      });
  }

  useFocusEffect(useCallback(() => fetchPageData(), []));

  const loading = productResult.loading || imagesResult.loading;
  const apolloError = productResult.error || imagesResult.error;

  if (loading) {
    // show skeleton if there's no previous data
    return <ProductImageDetailsSkeleton />;
  } else if (apolloError || error || !productResult.data?.product) {
    return (
      <PageErrorOccurred
        errorMessage={apolloError?.message}
        onRetry={fetchPageData}
      />
    );
  }

  return (
    <ProductImageDetailsScreenInner
      {...props}
      product={productResult.data?.product}
      images={imagesResult.data?.productImages || []}
    />
  );
};
